export const MENU_WIDTH = 250;
export const MEDIA_SCREEN_MENU_SWITCH_SIZE = 700;
export const MEDIA_SCREEN_LG = 992;